import { type ReactNode } from 'react';
import { None } from '@hungryroot/icons';
import { type PricingOption } from '@hungryroot/rest';
import { usePricingServiceCustomerContainerPriceOptions } from '../../hooks/usePricingServiceCustomerContainerPriceOptions';
import { Occasion } from '../Occasion/Occasion';

interface OccasionProps {
  testid?: string;
  heading: string;
  onDismiss?: () => void;
  onSubmit?: (value: string) => void;
  isSubmitting?: boolean;
  confirmButtonText: string;
  title: string;
  initialValue?: string | number;
  className?: string;
  customerId: number;
  containerId: number;
  icon?: ReactNode;
  editDisabled?: boolean;
  containerName: string;
  subtitle?: string;
}

function getQuantity(option: PricingOption) {
  if (option.TIERED !== null) {
    return option.TIERED.quantity;
  }

  if (option.SKU_QUANTITY !== null) {
    return option.SKU_QUANTITY.quantity;
  }

  return option.RECIPE_QUANTITY.quantity;
}

export function OccasionContainer(props: OccasionProps) {
  const { containerId, customerId, initialValue } = props;

  const { data, isLoading } = usePricingServiceCustomerContainerPriceOptions({
    customerId,
    containerId,
  });

  if (isLoading || !data) {
    return null;
  }

  const options = data?.pricing_options.map((option) => {
    // hardcoding this pricing configuration for now until we need to support multiple
    // pricing configurations
    return {
      label: option.name,
      value: String(getQuantity(option)),
      illustration: <img alt="" src={option.image_url || ''} />,
    };
  });

  const description = data.pricing_options.find((option) => {
    return getQuantity(option) === initialValue;
  });

  return (
    <Occasion
      {...props}
      // API does not return options for a 0 value in the pricing options so we have to do it manually
      options={[
        { label: 'Remove from plan', value: '0', illustration: <None /> },
        ...options,
      ]}
      description={description?.name || 'None'}
    />
  );
}
